<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11.587"
    height="11.669"
    viewBox="0 0 11.587 11.669">
    <g id="small-search" transform="translate(1.061 0.75)">
      <circle
        id="Ellipse_12"
        data-name="Ellipse 12"
        cx="4.083"
        cy="4.083"
        r="4.083"
        transform="translate(1.61)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        stroke-width="1.5" />
      <line
        id="Line_50"
        data-name="Line 50"
        x1="2.847"
        y2="2.847"
        transform="translate(0 7.012)"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="bevel"
        stroke-width="1.5" />
    </g>
  </svg>
</template>
